import Image from 'next/image';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

import { LockOutline as lockIcon } from '@calm-web/icons';

import { minWidth } from '../../utils/mediaQueries';
import { FontSizes, FontWeights } from '../../utils/typography/types';
import Badge from '../Badge';
import Text from '../Text';
import { TextElements } from '../Text/types';

export const BackgroundImage = styled(Image)`
	object-fit: cover;
	transition: ${theme('animation.transition')};
	position: absolute;
	top: 0;
	height: 100%;
	width: 100%;
	transition: all 0.3s ease;

	> div {
		height: 100%;
	}
`;

export const BackgroundImageWrapper = styled.div`
	left: 0;
	overflow: hidden;
	position: relative;
	top: 0;
	width: 100%;
	height: 100%;
`;

export const Title = styled(Text).attrs({
	el: TextElements.Div,
	size: FontSizes.lg,
	weight: FontWeights.Medium,
	color: 'white',
})``;

export const SubtitleElement = styled(Text).attrs({
	el: TextElements.Div,
	size: FontSizes.base,
	weight: FontWeights.Medium,
	color: 'white',
})``;

export const Subtitle = styled(SubtitleElement)`
	padding-bottom: 0.25em;
`;

export const DateTimeElement = styled(Text).attrs({
	el: TextElements.Div,
	size: FontSizes.sm,
	color: 'white',
})``;

export const DateTime = styled(DateTimeElement)`
	white-space: nowrap;
`;

export const LockIcon = styled(lockIcon)`
	background: rgba(0, 0, 0, 0.2);
	border-radius: 50%;
	height: 32px;
	width: 32px;
	left: 0.5em;
	padding: 0.25em 0.5em;
	position: absolute;
	top: 0.5em;
	& path {
		fill: ${palette('white')};
	}
	z-index: 10;
	line-height: 1.5em;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const LockWithBadge = styled.div`
	height: 32px;
	width: 32px;
`;

export const MultipleBadges = styled(Badge)<{ children: ReactNode }>`
	& first-child {
		margin-left: 20%;
	}
`;

export const ImageWrapper = styled.div<{
	height: number | undefined;
	width: number | undefined;
}>`
	border-radius: 1em;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
	display: flex;
	position: relative;
	flex-direction: column;
	overflow: hidden;
	position: relative;
	transition: ${theme('animation.transition')};
	height: ${p => p.height}px;
	max-width: ${p => p.width}px;

	${minWidth('tablet')} {
		height: ${p => p.height}px;
		max-width: ${p => p.width}px;
	}
`;

export const InfoContainer = styled.div`
	position: relative;
	margin-top: 0.75em;
	margin-bottom: 1em;
	height: 100%;
	width: 100%;

	${minWidth('tablet')} {
		margin-bottom: 1.5em;
	}
`;

export const CardContainer = styled.a<{ $isDisabled: boolean }>`
	position: relative;
	width: 100%;
	height: 100%;
	display: block;
	flex-wrap: wrap;
	opacity: ${p => (p.$isDisabled ? 0.2 : 1)};
	pointer-events: ${p => (p.$isDisabled ? 'none' : 'auto')};
	transition: opacity 0.3s ease;
	text-decoration: none;

	&:hover {
		${BackgroundImage} {
			transform: scale(1.05);
		}
	}
`;

export const BadgeGrid = styled.div`
	display: flex;
	grid-gap: 0.25em;
	align-items: center;
	margin-top: 0.5em;
	margin-left: 0.5em;

	${MultipleBadges} {
		z-index: 1;
	}
`;
